<template>
  <Modal v-bind="$attrs" @open="onModalOpen" @cancel="emits('cancel')" @confirm="onConfirm">
    <div class="query-form">
      <el-input v-model="queryString" clearable placeholder="请输入锚点名称"></el-input>
      <el-button class="query-btn" type="primary" @click="queryAction" :loading="queryLoading">查询</el-button>
    </div>
    <el-table v-loading="queryLoading" :data="tableData" height="180" class="common-el-table-styles" border style="width: 100%">
      <el-table-column width="width" label="锚点名称">
        <template slot-scope="{ row }">
          <el-radio class="profile-radio" v-model="anchorValue" :label="row.anchor_id">
            {{ row.anchor_name }}
          </el-radio>
        </template>
      </el-table-column>

      <el-table-column width="70" prop="status_text" label="状态"> </el-table-column>
    </el-table>
  </Modal>
</template>

<script setup>
import { ref } from 'vue'
import { Message } from 'view-design'
import Modal from '@/views/create/gdt/components/distribute/components/modal.vue'
import { nativeAnchorGet } from '@/api/toutiao.model'

// eslint-disable-next-line
const emits = defineEmits(['cancel', 'confirm'])
// eslint-disable-next-line
const props = defineProps({
  currentRow: Object
})

const queryString = ref('')
const anchorValue = ref('')
const queryLoading = ref(false)
const tableData = ref([])

const anchorStatus = [
  {
    value: 'AUDIT_SUCCESS',
    label: '审核通过'
  },
  {
    value: 'CREATE',
    label: '锚点新建'
  },
  {
    value: 'AUDIT_FAILED',
    label: '审核不通过'
  }
]

const queryAction = () => {
  queryLoading.value = true
  nativeAnchorGet({
    adAccountId: props.currentRow.ad_account_id,
    pageIndex: 1,
    pageSize: 50,
    anchorName: queryString.value,
    status: 'AUDIT_SUCCESS',
    source: ['CUSTOM', 'MANUAL'].join(',')
  })
    .then((data) => {
      const { list } = data
      if (list?.length) {
        tableData.value = list.map((row) => {
          const { status } = row
          return {
            ...row,
            status_text: anchorStatus.find((item) => item.value === status)?.label || '-'
          }
        })
      } else {
        tableData.value = []
      }
    })
    .finally(() => {
      queryLoading.value = false
    })
}

const onModalOpen = () => {
  queryString.value = ''
  anchorValue.value = ''
  queryAction()
}

const onConfirm = () => {
  const selectedRow = tableData.value.find((row) => {
    return row.anchor_id === anchorValue.value
  })

  if (!selectedRow) {
    return Message.warning('请选择锚点')
  }
  emits('confirm', selectedRow)
}
</script>

<style scoped lang="scss">
.query-form {
  display: flex;
  margin-bottom: 10px;
  .query-btn {
    margin-left: 10px;
  }
}
</style>
